import { BooleanField, FunctionField, Labeled, NumberField, Show, TabbedShowLayout, TextField, useRefresh, useTranslate } from 'react-admin'
import { Typography, Grid } from '@mui/material'
import { UserReadModel } from '../GeneratedClients/FreeBillApi'
import firstLetterToLowerCase from '../helpers/firstLetterToLowerCase'
import { HubConnection } from '@microsoft/signalr'
import UserShowActions from './UserShowActions'

interface IProps {
  connection?: HubConnection
}

const UserShow = ({connection} : IProps) => {
  const translate = useTranslate()
  const refresh = useRefresh()

  connection?.on("UserUpdated", () => {
    refresh()
  })

  return (
    <Show title={translate("resources.users.name", {smart_count: 1})} actions={<UserShowActions />}>
      <TabbedShowLayout >
        <TabbedShowLayout.Tab label="resources.company.userCompanyName" sx={{display: 'flex'}} >
          <Grid container justifyContent={'space-between'} pr={20}>
            <Grid item display={'flex'} flexDirection={'column'} >
              <Labeled>
                <TextField source="company.companyName" label="resources.company.userCompanyName" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.street" label="resources.company.street" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.postCode" label="resources.company.postCode" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.city" label="resources.company.city" emptyText='-' />
              </Labeled>
            </Grid>
            <Grid item display={'flex'} flexDirection={'column'} >
              <Labeled>
                <NumberField source="defaultDuePeriod" label="resources.users.defaultDuePeriod" emptyText='-' />
              </Labeled>
              <Labeled>
                <BooleanField source="isSmallBusiness" label="resources.users.isSmallBusiness" />
              </Labeled>
              <Labeled>
                <TextField source="taxNumber" label="resources.users.taxNumber" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="ustId" label="resources.users.ustId" emptyText='-' />
              </Labeled>
              <Labeled>
                <FunctionField 
                  render={(user: UserReadModel) => {
                    return <BooleanField source='isUstIdHidden' />
                  }}
                  label="resources.users.isUstIdHidden" 
                />
              </Labeled>
            </Grid>
            <Grid item display={'flex'} flexDirection={'column'} >
              <Labeled>
                <TextField source="company.localCourt" label="resources.company.localCourt" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.hrbNumber" label="resources.company.hrbNumber" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.managingDirector" label="resources.company.managingDirector" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.email" label="resources.company.email" emptyText='-' />
              </Labeled>
              <Labeled>
                <TextField source="company.website" label="resources.company.website" emptyText='-' />
              </Labeled>
            </Grid>
          </Grid>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="resources.contact.name" >
          <FunctionField 
            label="resources.contact.fullName"
            render={(user: UserReadModel) => <Typography variant="body2">{`${translate(`resources.contact.${firstLetterToLowerCase(user.contact?.gender)}`)} ${user.contact?.lastName}`}</Typography>}           
          />
          <TextField source="contact.firstName" label="resources.contact.fullName" emptyText='-' />
          <TextField source="contact.lastName" label="resources.contact.lastName" emptyText='-' />
          <TextField source="contact.email" label="resources.contact.email" emptyText='-' />
          <TextField source="contact.phone" label="resources.contact.phone" emptyText='-' />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="resources.bankAccount.name" >
          <TextField source="bankAccount.bankName" label="resources.bankAccount.bankName" emptyText='-' />
          <TextField source="bankAccount.accountOwner" label="resources.bankAccount.accountOwner" emptyText='-' />
          <TextField source="bankAccount.iban" label="resources.bankAccount.iban" emptyText='-' />
          <TextField source="bankAccount.bic" label="resources.bankAccount.bic" emptyText='-' />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  )
}

export default UserShow